import { useState } from "react";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

export default function TabelaArtigos({ data, months }) {
    const [month, setMonth] = useState(null);
    const [search, setSearch] = useState('');

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(rowData[props.field]);
    };

    let filteredData = month !== null ? data.filter((element) => {
        return parseInt(element.mes) === month;
    }) : data;

    filteredData = search.length ? filteredData.filter((element) => { return String(element.cod_artigo).includes(search) }) : filteredData;

    return (
        <div>
            <div className="p-d-flex p-jc-between p-mb-4">
                {months.map((item, index) => (
                    <Button
                        className={"p-m-1 p-button-secondary p-col " + (month === (index + 1) ? "p-button-success" : "")}
                        label={item}
                        key={`button${index}`}
                        onClick={() => {
                            setMonth((index + 1) === month ? null : (index + 1));
                        }}
                    />
                ))}
            </div>

            <div>
                <InputText 
                    className="p-m-1"
                    onChange={e => setSearch(e.target.value)}
                    value={search}
                />
                <Button 
                    className="p-m-1 p-button-danger"
                    icon="pi pi-times"
                    onClick={() => setSearch('')}
                    title='Clique para limpar a pesquisa'
                />
            </div>


            <DataTable
                responsiveLayout="scroll"
                size="small"
                value={filteredData}
            >
                <Column header="Artigo" field="cod_artigo" body={(rowData) => (
                    <h3 className="p-m-0">{rowData.cod_artigo}</h3>
                )} sortable />
                <Column header="Mês" field="mes" sortable />
                <Column header="Class. 1" field="class1" body={formatNumber} sortable />
                <Column header="Class. 2" field="class2" body={formatNumber} sortable />
                <Column header="Class. 3" field="class3" body={formatNumber} sortable />
                <Column header="Class. 4" field="class4" body={formatNumber} sortable />
                <Column header="Total" field="totalgeral" body={formatNumber} sortable />
            </DataTable>
        </div>
    )
}